export const WithdrawIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 14.5L8 2.5M8 2.5L12 6.5M8 2.5L4 6.5" stroke="white" />
    </svg>
  )
}
